// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import * as React from "react";
import { cn } from "../../lib/utils";

const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", ...props }, ref) => {
    const [isHovered, setIsHovered] = React.useState(false);
    
    const sizes = {
      default: "px-5 py-2.5",
      sm: "px-4 py-2 text-sm",
      lg: "px-7 py-3.5 text-lg"
    };

    // Styles de base
    const baseStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '0.5rem',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'none',
      border: 'none'
    };

    // Styles par variant
    const variantStyles = {
      default: {
        background: isHovered 
          ? 'var(--blue-light)' 
          : 'linear-gradient(135deg, var(--blue) 0%, var(--blue-light) 100%)',
        color: 'white',
        transform: isHovered ? 'translateY(-1px)' : 'translateY(0)',
        boxShadow: isHovered ? '0 4px 12px rgba(30, 58, 138, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
      },
      outline: {
        background: isHovered ? 'var(--blue)' : 'white',
        color: isHovered ? 'white' : 'var(--black)',
        border: `1px solid ${isHovered ? 'var(--blue)' : 'var(--gray)'}`
      },
      ghost: {
        background: isHovered ? 'rgba(30, 58, 138, 0.05)' : 'transparent',
        color: 'var(--black)'
      },
      destructive: {
        background: isHovered ? '#b91c1c' : '#dc2626',
        color: 'white',
        transform: isHovered ? 'translateY(-1px)' : 'translateY(0)',
        boxShadow: isHovered ? '0 4px 12px rgba(220, 38, 38, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)'
      }
    };

    const finalStyle = {
      ...baseStyle,
      ...variantStyles[variant]
    };

    return (
      <button
        className={cn(sizes[size], className)}
        style={finalStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button };